import { del, get, post, put } from './api.service';

const base_url = 'plans/v1';

export const getAll = (params: {
        page?: number,
        per_page?: number,
        search?: string,
        type?: string,
        status?: string,
        order?: string
} = {}) => {
    const queryString = Object.keys(params)
        .filter(key => params[key as keyof typeof params])
        .map(key => {
            return `${key}=${params[key as keyof typeof params]}`;
        }).join('&');

    let url = queryString ? base_url + `?${queryString}` : base_url;

    return get(url);
}

export const getById = (uuid: string) => {
    return get(`${base_url}/${uuid}`);
}

export const create = (data: object) => {
    return post(base_url, data);
}

export const update = (data: { values: object, uuid: string }) => {
    return put(`${base_url}/${data.uuid}`, data.values);
}

export const remove = (uuid: string | undefined) => {
    return del(`${base_url}/${uuid}`);
}

